import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleProgressiveType extends Cloneable {
    static NONE = new SmartOfferBundleProgressiveType(0, "NONE");

    static _values = [
        // new SmartOfferBundleProgressiveType(1, "FR"),
        // new SmartOfferBundleProgressiveType(2, "BK"),
        // new SmartOfferBundleProgressiveType(3, "BM"),
        new SmartOfferBundleProgressiveType(1, "MERGE"),
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SmartOfferBundleProgressiveType.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SmartOfferBundleProgressiveType) {
            return SmartOfferBundleProgressiveType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return SmartOfferBundleProgressiveType.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof SmartOfferBundleProgressiveType) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleProgressiveType());
        } else if (target instanceof SmartOfferBundleProgressiveType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleProgressiveType, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});